<template>
  <mds-form class="filter-bar">
    <mds-fieldset
      horizontal
      class="filter-bar__filters"
    >
      <!-- Expects MDS form elements (input, select, etc.) -->
      <slot />
    </mds-fieldset>
    <mds-button
      variation="icon-only"
      icon="refresh"
      size="small"
      type="button"
      class="filter-bar__clear"
      @click="$emit('clear')"
    >
      Clear
    </mds-button>
  </mds-form>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsFieldset from '@mds/fieldset'
import MdsForm from '@mds/form'

export default {
  components: {
    MdsButton,
    MdsFieldset,
    MdsForm,
  },
}
</script>

<style lang="scss">
.filter-bar {
  display: flex;
  align-items: flex-end;
}

.filter-bar__filters {
  margin-bottom: -#{$mds-space-2-and-a-half-x}; // Account for form fields having bottom margin
}

.filter-bar__clear {
  margin: 0 0 $mds-space-1-x $mds-space-1-and-a-half-x;
}
</style>

<style lang="scss" module>
// MDS overrides
:global(.filter-bar) {
  .mds-label {
    flex: 1 0 0; // Ensure all filters are the same width
  }
}
</style>
